/* eslint-disable react/no-array-index-key */
import { Table } from '@m/alchemy-ui/Table';
import { TableCell } from '@m/alchemy-ui/TableCell';
import { TableRow } from '@m/alchemy-ui/TableRow';
import styled from 'styled-components';

export const NativeTh = styled.th`
  margin: 0;
  padding: 10px 6.4px;
  position: relative;
  text-align: left;
  vertical-align: middle;
  white-space: nowrap;
`;

// Remove it after migration to Alchemy charts
export const TableView = ({
  columns,
  rows,
  formatDate,
  onRowClick,
  summary
}: {
  columns: { label: string }[];
  rows: (string | number | Date)[][];
  formatDate: (date: Date) => string;
  onRowClick?: (index: number) => void;
  summary?: string;
}) => {
  return (
    <Table>
      {summary && <caption className="sr-only">{summary}</caption>}
      <thead>
        <TableRow>
          {columns.map((column) => (
            <NativeTh scope="col" key={column.label}>
              {column.label}
            </NativeTh>
          ))}
        </TableRow>
      </thead>
      <tbody>
        {rows.map((row, rowIndex) => {
          const key = row[0] instanceof Date ? (row[0] as Date).toISOString() : rowIndex;
          return (
            <TableRow
              key={key}
              onClick={onRowClick ? () => onRowClick(rowIndex) : undefined}
              style={onRowClick ? { cursor: 'pointer' } : undefined}
            >
              {row.map((cell, cellIndex) => {
                const content = cell instanceof Date ? formatDate(cell) : String(cell);

                if (cellIndex === 0) {
                  return (
                    <NativeTh
                      scope="row"
                      key={`${key}-${cellIndex}`}
                      tabIndex={0}
                      onClick={onRowClick ? () => onRowClick(rowIndex) : undefined}
                      onKeyDown={
                        onRowClick
                          ? (e) => {
                              if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                onRowClick(rowIndex);
                              }
                            }
                          : undefined
                      }
                      style={onRowClick ? { cursor: 'pointer' } : undefined}
                    >
                      {content}
                    </NativeTh>
                  );
                }

                return <TableCell key={`${key}-${cellIndex}`}>{content}</TableCell>;
              })}
            </TableRow>
          );
        })}
      </tbody>
    </Table>
  );
};
